var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.2572L7.695 16.0692C3.06 11.8662 0 9.08519 0 5.69219C0 2.91119 2.178 0.742188 4.95 0.742188C6.516 0.742188 8.019 1.47119 9 2.61419C9.981 1.47119 11.484 0.742188 13.05 0.742188C15.822 0.742188 18 2.91119 18 5.69219C18 9.08519 14.94 11.8662 10.305 16.0692L9 17.2572Z",
    fill: "#8C8989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/Favorites.d384b15d53fd222e63235c41851c9906.svg";
export { ForwardRef as ReactComponent };